import {ICustomTableColumn} from '~/components/CustomTable';

import PricingTableActionsHandlerContainer from './PricingTableActionsHandlerContainer';

export const ACTION_CONSTANTS = {
  DELETE: 'delete',
  EDIT: 'edit',
};

const consultationColumns = (): ICustomTableColumn<TAllRowTypes>[] => [
  {
    key: 'actions',
    label: '',
    render: (_: string | undefined, rowData: TAllRowTypes) => (
      <PricingTableActionsHandlerContainer rowData={rowData} />
    ),
    className: 'w-1/12 px-2',
  },
  {
    key: 'consultant_name',
    label: 'Consultation',
    isBold: true,
    isSortable: true,
  },
  {
    key: 'consultation_fee',
    label: 'New Patient Consultation',
    isSortable: true,
  },
  {key: 'followup_fee', label: 'Follow Up', isSortable: true},
];

const diagnosticColumns = (): ICustomTableColumn<TAllRowTypes>[] => [
  {
    key: 'actions',
    label: '',
    render: (_: string | undefined, rowData: TAllRowTypes) => (
      <PricingTableActionsHandlerContainer rowData={rowData} />
    ),
    className: 'w-1/12 px-2',
  },
  {
    key: 'ccsd_code',
    label: 'CCSD Code',
    isBold: true,
    isSortable: true,
    render: (value: string | undefined) => value || ' -- ',
  },
  {key: 'description', label: 'Test'},
  {key: 'procedure_price', label: 'Fee', isSortable: true},
];

const refractiveColumns = (): ICustomTableColumn<TAllRowTypes>[] => [
  {
    key: 'actions',
    label: '',
    render: (_: string | undefined, rowData: TAllRowTypes) => (
      <PricingTableActionsHandlerContainer rowData={rowData} />
    ),
    className: 'w-1/12 px-2',
  },
  {
    key: 'ccsd_code',
    label: 'CCSD Code',
    isBold: true,
    isSortable: true,
    render: (value: string | undefined) => value || ' -- ',
  },
  {key: 'description', label: 'Procedure Description'},
  {key: 'eye_involvement', label: 'One Eye/Both'},
  {key: 'procedure_price', label: 'Procedure Price', isSortable: true},
];

const addonsColumns = (): ICustomTableColumn<TAllRowTypes>[] => [
  {
    key: 'actions',
    label: '',
    render: (_: string | undefined, rowData: TAllRowTypes) => (
      <PricingTableActionsHandlerContainer rowData={rowData} />
    ),
    className: 'w-1/12 px-2',
  },
  {
    key: 'ccsd_code',
    label: 'CCSD Code',
    isBold: true,
    isSortable: true,
    render: (value: string | undefined) => value || ' -- ',
  },
  {key: 'description', label: 'Add-on Description', isSortable: true},
  {key: 'eye_involvement', label: 'One Eye/Both'},
  {key: 'procedure_price', label: 'Add-on Price', isSortable: true},
];

// this is categories to their respective columns mapping
export const pricingListCategoryToColumnMap: Record<
  string,
  ICustomTableColumn<TAllRowTypes>[]
> = {
  consultation: consultationColumns(),
  diagnostic: diagnosticColumns(),
  refractive: refractiveColumns(),
  retinal: refractiveColumns(),
  oculoplastics: refractiveColumns(),
  corneal: refractiveColumns(),
  glaucoma: refractiveColumns(),
  addons: addonsColumns(),
};

export const categoryKeyToDisplayNameMap: Record<string, string> = {
  consultation: 'Consultation',
  diagnostic: 'Diagnostic/Other Fees',
  refractive: 'Refractive/Cataract',
  retinal: 'Retinal',
  oculoplastics: 'Oculoplastics and Lacrimal',
  corneal: 'Corneal and Conjunctival',
  glaucoma: 'Glaucoma',
  addons: 'Add-ons',
};
